import { connect } from 'react-redux'
import ListItemUser from './ListItemUser'
import {
  showProfile
} from 'store/redux/layout'

export default connect(
  null,
  {
    showProfile
  }
)(ListItemUser)

